(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sticky-add-cart"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-zirelo-sticky-add-to-cart]');
  if (!trigger) return;

  const productForm = document.querySelector('[data-product-form]');
  const submitButton = productForm?.querySelector('button[type="submit"][name="add"]');

  if (!productForm || !submitButton || submitButton.disabled) return;

  if (typeof productForm.requestSubmit === 'function') {
    productForm.requestSubmit(submitButton);
    return;
  }

  submitButton.click();
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["zirelo-logo-home-link"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const logoLink = event.target.closest('.site-header__logo-link');

    if (!logoLink) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(logoLink.href);
  }, true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["zirelo-native-mobile-cart"] && !Shopify.designMode) return;
  try {
    const bindZireloNativeMobileCart = () => {
    if (!window.matchMedia('(max-width: 769px)').matches) return;

    document.querySelectorAll('[data-product-form]').forEach((form) => {
      if (form.dataset.zireloNativeMobileCart === 'true') return;

      form.dataset.zireloNativeMobileCart = 'true';
      form.addEventListener('submit', async (event) => {
        const variantInput = form.querySelector('[name="id"]');

        if (!variantInput || !variantInput.value) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        const submitButton = form.querySelector('[name="add"]');
        const rootUrl = window.Shopify?.routes?.root || '/';
        const quantityInput = form.querySelector('[name="quantity"]');
        const quantity = Math.max(1, Number.parseInt(quantityInput?.value || '1', 10));
        const productContainer = form.closest('[data-product-id]');
        const productJson = productContainer?.querySelector('.mainProductJson');
        const optionInputs = Array.from(form.querySelectorAll('select.js-single-option-selector, input.js-single-option-selector:checked'))
          .sort((first, second) => {
            const firstIndex = Number.parseInt(first.dataset.index?.replace('option', '') || '0', 10);
            const secondIndex = Number.parseInt(second.dataset.index?.replace('option', '') || '0', 10);
            return firstIndex - secondIndex;
          });
        let variantId = Number.parseInt(variantInput.value, 10);

        if (productJson && optionInputs.length) {
          const productData = JSON.parse(productJson.textContent);
          const selectedOptions = optionInputs.map((input) => input.value);
          const selectedVariant = productData.variants.find((variant) =>
            selectedOptions.every((value, index) => variant.options[index] === value)
          );

          if (selectedVariant) variantId = selectedVariant.id;
        }

        if (submitButton) submitButton.disabled = true;

        try {
          const response = await fetch(`${rootUrl}cart/add.js`, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              items: [{ id: variantId, quantity }]
            }),
            credentials: 'same-origin'
          });
          const result = await response.json();

          if (!response.ok) throw new Error(result.description || result.message);

          const cartResponse = await fetch(`${rootUrl}cart.js`, {
            headers: { Accept: 'application/json' },
            credentials: 'same-origin',
            cache: 'no-store'
          });
          const cart = await cartResponse.json();

          document.querySelectorAll('[data-cart-count], .cart-count').forEach((counter) => {
            counter.textContent = cart.item_count;
            counter.classList.remove('hide');
          });
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart, result } }));
          if (submitButton) submitButton.disabled = false;
        } catch (error) {
          if (submitButton) submitButton.disabled = false;
          window.alert(error.message);
        }
      }, true);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindZireloNativeMobileCart, { once: true });
  } else {
    bindZireloNativeMobileCart();
  }
  } catch(e) { console.error(e); }
})();

})();
